export default class Expand extends CustomEvent {
    constructor(caller) {
        super('expand', {
            bubbles: false,
            detail: {
                caller
            }
        });
    }
}
